import { render, staticRenderFns } from "./BAutocompleteSelectHandbook.vue?vue&type=template&id=7fdea424&"
import script from "./BAutocompleteSelectHandbook.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteSelectHandbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports